import React from 'react'
import "./AmpleHome.css";
import AmpleHeroSection from './HomeSectionsComponents/AmpleHeroSection';


import WhatWeDoSection from './HomeSectionsComponents/WhatWeDoSection';
import LeadershipModel from './HomeSectionsComponents/LeadershipModel';
import IntellectualSection from './HomeSectionsComponents/IntellectualSection';
import WorkWithUsSection from './HomeSectionsComponents/WorkWithUsSection';
import OurPartnersPage from './HomeSectionsComponents/OurPartnersPage';
import EventsPage from '../AmpleEventComponents/EventsPage';


export default function AmpleHome() {
  return (
      <div className="page-container">
        <AmpleHeroSection/>
         <WhatWeDoSection/>
         <LeadershipModel/>
         <IntellectualSection/>
         <WorkWithUsSection/>
         <EventsPage/>
         <OurPartnersPage/>
    
       
    
        
      </div>
  )
}
